import { Fetch, FetchAttachment } from '../Models/shared/general';

//#region ======== ACTIONS ========
const actions = {
    //======== CLAIM MANAGEMENT ======
    claim_claim_create      : "claim_claim_create",
    claim_list_get          : "claim_list_get",
    claim_limit_get         : "claim_limit_get",
    claim_userid_get        : "claim_userid_get",
    claim_claim_update      : "claim_claim_update"

};
//#endregion


//#region ========== API FUNCTIONS ===========
export async function claim_claim_create(data){
    return Fetch({ action: actions.claim_claim_create, data: data });
}

export async function claim_list_get(data){
    return Fetch({ action: actions.claim_list_get, data: data });
}

export async function claim_limit_get(data){
    return Fetch({ action: actions.claim_limit_get, data: data });
}

export async function claim_userid_get(data){
    return Fetch({ action: actions.claim_userid_get, data: data });
}

export async function claim_claim_update(data){
    return Fetch({ action: actions.claim_claim_update, data: data });
}
//#endregion

//#region ========= ATTACHMENT =========
export async function claim_attachment_create(data){
    return FetchAttachment({ data: data })
}